import React from 'react';
import { useSalon } from '../context/SalonContext'; // Import context
import Hero from './Hero';
import About from './About';
import OpeningHours from './OpeningHours';
import LocationMap from './LocationMap';
import Gallery from './Gallery';
import PriceList from './PriceList';
import ServicesList from './ServicesList';
import UmaiProductsSection from './UmaiProductsSection';
import GaiaProductsSection from './GaiaProductsSection';
import InstagramFeed from './InstagramFeed';
import Facebook from './Facebook';
import PhoneBooking from './PhoneBooking';
import NotreEngagement from './NotreEngagement';
import BookingFormPB from './BookingFormPB';

function HomeContent() {
    const { salonInfos, loading } = useSalon();

    // Par sécurité, on considère activé par défaut tant qu'on n'a pas la preuve du contraire (false)
    // Cela permet d'afficher le formulaire pendant le chargement ou si la config manque.
    const onlineBookingEnabled = salonInfos?.booking_enabled !== false;

    return (
        <>
            <Hero />
            <About />
            <ServicesList />
            <PriceList />
            <UmaiProductsSection />
            <GaiaProductsSection />
            <NotreEngagement />
            <Gallery />
            <InstagramFeed />
            <Facebook />

            <section id="reservation" className="booking-section">
                <div className="container">
                    {/* On garde PhoneBooking mais on ajoute le formulaire en ligne */}
                    <PhoneBooking />

                    {/* Affichage conditionnel du formulaire de réservation */}
                    {onlineBookingEnabled && (
                        <div style={{ marginTop: '3rem', animation: 'fadeIn 0.5s' }}>
                            <BookingFormPB />
                        </div>
                    )}
                </div>
            </section>

            <section id="location" className="location-hours-section">
                <div className="container">
                    <div className="location-hours-wrapper">
                        <LocationMap />
                        <OpeningHours />
                    </div>
                </div>
            </section>
        </>
    );
}

export default HomeContent;
